// Dependencies
import React, { Component, PropTypes } from 'react';
// Components
import Card from '../tc-ui/card';
import List from './connections-list';
import ConnectionsToolBar from './connections-toolbar/connections-toolbar';
import languageObj from '../../localization/languages.json';
const languageSettings = languageObj['en-US'];

class Connections extends Component {

  constructor(props) {
    super(props);
    this.state = { isFixed: false };
  }


  componentDidMount() {
    if (window.addEventListener) {
      window.addEventListener('scroll', this.onScroll, false);
    } else {
      window.attachEvent('onscroll', this.onScroll);
    }
  }

  componentWillUnmount() {
    if (window.addEventListener) {
      window.removeEventListener('scroll', this.onScroll, false);
    } else {
      window.detachEvent('onScroll', this.onScroll);
    }
  }

  onScroll = () => {
    if (document.body.scrollTop >= 32 !== this.state.isFixed) this.setState({ isFixed: !this.state.isFixed });
  };

  render() {
    const { input, history } = this.props;
    const title = (() => {
      const { invites, requests, connected } = languageSettings.connections.routeNames;
      if (input) return 'Search Results';
      if (history.isActive('/connections/invitations')) return invites;
      if (history.isActive('/connections/requests')) return requests;
      return connected;
    })();

    const connectionsToolBar = this.props.filterOptions.length ? <ConnectionsToolBar {...this.props} /> : undefined;
    return (
        <div className="l-left-nav-content">
          <Card
            title={connectionsToolBar ? undefined : title}
            isFixed={this.state.isFixed}
            isSticky
            searchHeader
            listCard
            padded={false}
            {...this.props}
          >
            {connectionsToolBar}
            <List {...this.props} />
          </Card>
        </div>
    );
  }
}

Connections.propTypes = {
  connectionsStats: PropTypes.object,
  filterOptions: PropTypes.array,
  connections: PropTypes.object,
  input: PropTypes.string,
  history: PropTypes.object,
};


export default Connections;



// WEBPACK FOOTER //
// ./src/app/components/connections/connections.jsx